import { createTheme } from "@econans/ui-components";

export const theme = createTheme({
    baseSpacing: { amount: 4, unit: "px" },
});
